<template>
  <div class="account-advantages">
    <div
      v-for="(item, index) in advantages"
      :key="index"
      class="account-advantages__item">
      <div class="account-advantages__icon">
        <img
          :src="item.icon"
          :alt="item.title">
      </div>
      <div class="account-advantages__content">
        <h4 class="account-advantages__title">
          {{ item.title }}
        </h4>
        <p class="account-advantages__text">
          {{ item.text }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AccountAdvantages',

  props: {
    advantages: {
      type: Array,
      default: () => [
        {
          icon: '/images/icons/offer_advantages/sold_skycoach.svg',
          title: 'Sold by Skycoach',
          text: 'We only sell legit, fully verified accounts',
        },
        {
          icon: '/images/icons/offer_advantages/fast_delivery.svg',
          title: 'Fast delivery',
          text: 'Most accounts are delivered instantly, others within an hour',
        },
        {
          icon: '/images/icons/offer_advantages/hassle_free.svg',
          title: 'Hassle-free guarantee',
          text: 'If anything’s wrong, we’ll swap your account or refund you',
        },
      ],
    },
  },
};
</script>

<style scoped lang="scss">
.account-advantages {
  display: grid;
  grid-template-columns: repeat(3, minmax(1px, 1fr));
  align-self: flex-start;
  gap: 24px;
}

.account-advantages__item {
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;
  padding: 24px;
  border-radius: 16px;
  border: 1px solid $color--basic-menu;
  background: rgba(33, 48, 65, 0.40);
}

.account-advantages__content {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.account-advantages__icon {
  flex-shrink: 0;
  display: flex;
  width: 48px;
  height: 48px;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: center;
  }
}

.account-advantages__title {
  font-weight: 500;
  font-size: 15px;
  line-height: normal;
}

.account-advantages__text {
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
}

@media screen and #{$screen-less-than-1280} {
  .account-advantages {
    grid-template-columns: minmax(1px, 1fr);
    gap: 16px;
  }

  .account-advantages__item {
    flex-direction: row;
  }
}

@media screen and #{$screen-less-than-640} {
  .account-advantages {
    grid-template-columns: repeat(3, minmax(280px, 1fr));
    width: calc(100% + var(--padding) * 2);
    margin-left: calc(-1 * var(--padding));
    padding: 0 var(--padding);
    overflow-x: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
    gap: 16px;

    &::-webkit-scrollbar {
      display: none;
    }

    > * {
      flex-shrink: 0;
    }
  }

  .account-advantages__item {
    align-items: center;
  }
}
</style>
